export enum AccountType {  
  SelectOne = "",
  Residential = "Residential",
  Business = "Business"
}

export const AccountTypes: Record<keyof typeof AccountType, string> = {
  SelectOne: "Select Account Type",
  Residential: "Residential",
  Business: "Business"
};